// 这个是最终的打包文件，包含了所有模块的js代码
/* ------------------------------------------------
第一部分：固定内容，无需修改
--------------------------------------------------*/
// 初始化
window.$ = window.jQuery = require('jquery');
window.desktop_to_mobile = 992;
/* ------------------------------------------------
第二部分：自定义内容
--------------------------------------------------*/
import './_js/_custom.mjs';  // 自定义JS文件
/* ------------------------------------------------
第三部分：样式文件
--------------------------------------------------*/
import './app.less';  // CSS文件